import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47c927dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "text-white p-7 pb-10 flex-grow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl" }, "Game Tokens", -1))
const _hoisted_4 = {
  key: 0,
  class: "my-5 text-gray-text"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Link the Token you would like to this game in ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Token List page")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". Refer to ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://developers.xarcade.io/docs/Onboarding/link_token_to_game",
  target: "_new",
  class: "text-blue-primary hover:underline"
}, "guide", -1))
const _hoisted_9 = {
  key: 1,
  class: "my-5 text-gray-text"
}
const _hoisted_10 = { class: "md:grid md:grid-cols-2 lg:grid-cols-3" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "title m-0 text-blue-primary" }
const _hoisted_13 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_14 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_15 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_16 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-2xl w-full m-2" }
const _hoisted_17 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_18 = { class: "modal-content bg-black-body text-white" }
const _hoisted_19 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-md mb-5 text-center font-bold" }, "Select Tokens", -1))
const _hoisted_21 = { class: "border-0 grid md:grid md:grid-cols-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "xr-icon-token text-white h4 m-0"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 2,
  class: "px-2 m-0"
}
const _hoisted_26 = {
  key: 0,
  class: "text-md col-span-2"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode("No available token. ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Create a token")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" before linking it to your game")
const _hoisted_30 = { class: "flex justify-between items-center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.attachedTokens.length < 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: { name: 'viewTokensList' },
              class: "text-blue-primary hover:underline transition-all duration-200"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7,
            _hoisted_8
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, "Currently linked token" + _toDisplayString(_ctx.attachedTokens.length > 1?'s':'') + ":", 1)),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachedTokens, (token) => {
          return (_openBlock(), _createElementBlock("div", {
            key: token.tokenId,
            class: "bg-black-primary mr-3 mb-3 text-left p-5 drop-shadow-md rounded-sm flex items-center"
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(token.description ? token.description : token.tokenTitle), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayGameTokenModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayGameTokenModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDisplayGameTokenModel = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["p-3 px-4 items-center flex rounded-md m-2", [item.tokenId == this.selectedToken ? 'bg-blue-primary' : 'bg-black-primary cursor-pointer']]),
                              onClick: ($event: any) => (_ctx.selectAttachedTokenFunc(item.tokenId)),
                              key: item.tokenId
                            }, [
                              (item.logo === '' || item.logo === null)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "w-5 h-5",
                                    src: _ctx.assetUrl + 'blob/tokens/' + item.tokenId + '/' + item.logo
                                  }, null, 8, _hoisted_24)),
                              (item.description !== '')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(item.title?item.title:item.description), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_22))
                          }), 128)),
                          (_ctx.tokens.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode(_component_router_link, {
                                  class: "text-blue-primary hover:underline duration-200 transition-all",
                                  to: { name: 'viewTokensCreate', params: { network: 'testnet' } }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_28
                                  ]),
                                  _: 1
                                }),
                                _hoisted_29
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("button", {
                            class: "btn text-gray-text hover:text-gray-200 duration-200 transition-all mt-3",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayGameTokenModel = false))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            class: "btn btn-primary mt-3 float-end px-5",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveAttachedToken && _ctx.saveAttachedToken(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-save",
                              class: "inline-block mr-2"
                            }),
                            _hoisted_31
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}